export default "__VITE_ASSET__C5sCdEXk__"